module.exports = __webpack_public_path__ + "img/xiangcaoxuelong.5a7132b9.jpg";